import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { IconButton } from "@totalsoft/rocket-ui";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";

export const PartnerShareholderParentRowComponent = ({
  shareholder,
  openPartnerWindow,
  viewShareholderPhone 
}) => {
  const { t } = useTranslation();

  return (
    <Grid container ml="4" alignItems="center">
      <Grid item xs={12} md={3}>
        {t("Partner.UniqueID")} : <span>{shareholder.uniqueID || ""}</span>
      </Grid>
      <Grid item xs={12} md={5}>
        {t("Partner.Name")} : <span>{shareholder.shareHolderPartnerName || ""}</span>
      </Grid>
      {viewShareholderPhone  && (
        <Grid item xs={12} md={2}>
          {t("Partner.Phone")} : <span>{shareholder.shareHolderPhoneNumber || ""}</span>
        </Grid>
      )}
      <Grid item xs={12} md={1}>
        {t("Partner.Percent")} : <span>{t("PERCENT_NUMBER", { number: shareholder.sharePercent })}%</span>
      </Grid>
      <Grid item xs={12} sm={1} md={1}>
        <IconButton
          id={"shareholder_" + shareholder.partnerShareHolderId + "_editLevel2Shareholder"}
          color="primary"
          variant="text"
          onClick={openPartnerWindow(shareholder.shareHolderPartnerId)}
          tooltip={t("Tooltips.EditShareholder")}
        >
          <PersonIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

PartnerShareholderParentRowComponent.propTypes = {
  shareholder: PropTypes.object.isRequired,
  openPartnerWindow: PropTypes.func.isRequired,
  viewShareholderPhone : PropTypes.bool.isRequired
};

export default PartnerShareholderParentRowComponent;
